import api from 'config/api';

export default {
  getUserInformation: () => api.get('backoffice_api/v1/admin_users')
};
